import axios from "axios";
import {baseURL} from "../config/api";

export const getAllowDenyStatus = () => {
    return axios({
        url: baseURL + "allowDenyStatuses",
        method: "GET"
    }).then(response => response.data);
};
